import { curry, flip, objOf, pipe } from 'rambda'
import { _ } from '@feathersjs/commons'
import { parseObject } from '@store/utils'

const { merge } = _

export { merge as mergeDeepAssign }

export const propOf = curry((object, key) => object[key])

export const clone = pipe(
  JSON.stringify,
  JSON.parse,
)

export const detach = pipe(
  clone,
  parseObject,
)

// TODO: support deep spec properties
export const assignSpec = curry((spec, object) => {
  const appended = Object
    .entries(spec)
    .map(([key, value], index) => [key, value(object, index)])

  return appended.length
    ? { ...object, ...Object.fromEntries(appended) }
    : object
})

// eslint-disable-next-line unicorn/prevent-abbreviations
export const objOfPath = curry((path, value) => path
  .reduceRight(flip(objOf), value))
